import { defineComponent, onMounted, ref } from 'vue';
export const ClientOnly = defineComponent({
    setup(_, ctx) {
        const isMounted = ref(false);
        onMounted(() => {
            isMounted.value = true;
        });
        return () => { var _a, _b; return (isMounted.value ? (_b = (_a = ctx.slots).default) === null || _b === void 0 ? void 0 : _b.call(_a) : null); };
    },
});
